"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLabel = exports.printLabel = void 0;
const jspdf_1 = __importDefault(require("jspdf"));
const __1 = require("..");
const printLabel_1 = require("./printLabel");
const utils_1 = require("./utils");
const printLabel = (product, skus, contentVal) => {
    const { labelTitle, doc } = exports.createLabel(product, skus, contentVal);
    // automatically open print dialogue in pdf
    doc.autoPrint({ variant: 'non-conform' });
    doc.save(labelTitle);
};
exports.printLabel = printLabel;
const createLabel = (product, skus, contentVal) => {
    const doc = new jspdf_1.default({
        unit: 'in',
        orientation: utils_1.CONFIG.orientation,
        format: utils_1.CONFIG.format
    });
    let labelTitle = 'default-label-title.pdf';
    switch (product.productType) {
        case __1.ProductTypes.Fabric:
            labelTitle = printLabel_1.printFabricLabel(product, skus, doc, contentVal);
            break;
        case __1.ProductTypes.Zippers:
            labelTitle = printLabel_1.printZipperLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes.Ribbing:
            labelTitle = printLabel_1.printRibbingLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes['Sewing Patterns']:
            labelTitle = printLabel_1.printSewingPatternLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes.Buttons:
            labelTitle = printLabel_1.printButtonProductLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes.Thread:
            labelTitle = printLabel_1.printThreadLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes.Trim:
            labelTitle = printLabel_1.printTrimLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes.Elastic:
            labelTitle = printLabel_1.printElasticLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes['Bias Tape']:
            labelTitle = printLabel_1.printBiasTapeLabel(product, skus[0], doc);
            break;
        case __1.ProductTypes['Other Supply']:
            labelTitle = printLabel_1.printOtherSupplyLabel(product, skus[0], doc);
            break;
        default:
            throw new Error('Unexpected product type.');
    }
    return { labelTitle, doc };
};
exports.createLabel = createLabel;
//# sourceMappingURL=index.js.map